import { capitalize, generateUtilityClass, generateUtilityClasses, unstable_composeClasses } from "@mui/material";
const calendarDayName = "CalendarDay";
const calendarDayClasses = generateUtilityClasses(calendarDayName, [
  // root slot classes
  "root",
  "firstofRow",
  "adjacentMonth",
  "firstNonArchivedDate",
  "typeDay",
  "typeEmpty",
  "typeDayOfWeek",
  "rootSelectionDay",
  "rootSelectionRangeStart",
  "rootSelectionRangeMiddle",
  "rootSelectionRangeEnd",
  // button slot classes
  "button",
  "disabled",
  "buttonSelectionDay",
  "buttonSelectionRangeStart",
  "buttonSelectionRangeMiddle",
  "buttonSelectionRangeEnd",
  // label slot classes
  "label",
  "today",
  // dot slot classes
  "dot",
  // separator slot classes
  "separator",
  // tooltip slot classes
  "tooltip"
]);
function getCalendarDayUtilityClass(slot) {
  return generateUtilityClass(calendarDayName, slot);
}
function useCalendarDayUtilityClasses(ownerState) {
  const { classes, day, selection } = ownerState;
  const isToday = day.type === "day" && day.isToday;
  const isDisabled = day.type === "day" && day.disabled;
  const isAdjacentMonth = day.type === "day" && day.isAdjacentMonth;
  const isFirstNonArchivedDate = day.type === "day" && day.isFirstNonArchivedDate;
  const slots = {
    root: [
      "root",
      `type${capitalize(day.type)}`,
      selection && `rootSelection${capitalize(selection)}`,
      isAdjacentMonth && "adjacentMonth",
      isFirstNonArchivedDate && "firstNfirstNonArchivedDateon"
    ],
    button: ["button", isDisabled && "disabled", selection && `buttonSelection${capitalize(selection)}`],
    label: ["label", isToday && "today"],
    dot: ["dot"],
    separator: ["separator"],
    tooltip: ["tooltip"]
  };
  return unstable_composeClasses(slots, getCalendarDayUtilityClass, classes);
}
export {
  calendarDayClasses,
  calendarDayName,
  useCalendarDayUtilityClasses
};
//# sourceMappingURL=classes.js.map
